import { render, staticRenderFns } from "./WordList.vue?vue&type=template&id=2520fd66&scoped=true&lang=pug"
import script from "./WordList.vue?vue&type=script&lang=ts"
export * from "./WordList.vue?vue&type=script&lang=ts"
import style0 from "./WordList.vue?vue&type=style&index=0&id=2520fd66&prod&lang=stylus&scoped=true"
import style1 from "./WordList.vue?vue&type=style&index=1&id=2520fd66&prod&lang=stylus&scoped=true"
import style2 from "./WordList.vue?vue&type=style&index=2&id=2520fd66&prod&lang=stylus&scoped=true"
import style3 from "./WordList.vue?vue&type=style&index=3&id=2520fd66&prod&lang=stylus"
import style4 from "./WordList.vue?vue&type=style&index=4&id=2520fd66&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2520fd66",
  null
  
)

export default component.exports